import { gql } from '@apollo/client';

const query = gql`
  query localsearchCMSArticles($categoryName: String, $size: Int) {
    localsearchCMSArticles(categoryName: $categoryName, size: $size) {
      results {
        article {
          articleTitle
          urlSlug
          featureImageUrl
          wordCount
        }
      }
      categories {
        name
        featureImage
      }
    }
  }
`;

module.exports = query;
